// extracted by mini-css-extract-plugin
export default {"title":"TitleSearch_title__U9fql"};